import { formatDate } from 'src/utils/formatTime';

// The note every status form starts with, for the user to edit before saving.
export const buildDefaultStatusNote = email =>
  `Status changed by ${email || 'an unknown user'} on ${formatDate(new Date())}`;
